import { DateTime } from 'luxon';

export class BaseEntityUtils {
  getDefaultString(val: string | undefined | null = undefined): string {
    return val === undefined || val === null ? '' : val;
  }

  getDefaultBoolean(val: boolean | undefined = undefined): boolean {
    return val === undefined ? false : val;
  }

  getDefaultNumber(
    val: number | undefined = undefined,
    defValue: number | string = '',
  ): number | string {
    return val === undefined ? defValue : val;
  }

  getDefaultDate(val: string | null | undefined = undefined): DateTime | null {
    return val ? DateTime.fromISO(val) : null;
  }
}
